export const isEmptyObject = (value) => {
  // Check for null or undefined
  if (value == null) return true;

  // Check for empty string
  if (typeof value === "string") return value.trim().length === 0;

  // Check for empty array
  if (Array.isArray(value)) return value.length === 0;

  // Check for empty object
  if (typeof value === "object") return Object.keys(value).length === 0;

  return false;
};

export const isNotEmptyObject = (value) => !isEmptyObject(value);

export const sanitizeText = (value) =>
  String(value ?? "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\u00A0/g, " ")
    .trim();
